import * as React from 'react';



export default class TwoLayout extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd">
            <g transform="translate(1 2)">
                <path stroke="#000" strokeLinecap="round" d="M.538 1.615h12.924M.538 4.77H3.77M.538 6.923H3.77"/>
                <path fill="#43ADF1" d="M12 4h1v7h-1z"/>
                <path stroke="#000" strokeLinecap="round" d="M.538 9.077H3.77"/>
                <rect width="7.615" height="7.615" x="5.885" y="3.731" stroke="#000" rx="1"/>
            </g>
        </g>
      </svg>
    )
  }
}
